/**
 * Implementation of setTimeout that works with promises
 * @param miliseconds waiting time in miliseconds
 * @returns promise
 */
export default function wait(miliseconds): Promise<void> {
    return new Promise(success => setTimeout(success, miliseconds));
}